import React from 'react';
import './machine_css.css';
import { Link } from 'react-router-dom';

export default function MachineCategoryCard(props) {
  console.log('props.showName', props.showName);
  let linkTo = '';
  if (props.cateEn) {
    if (props.cateEn == 'Brands') {
      linkTo = `/machineUI/brands/${props.machineID}`;
    } else if (props.cateEn == 'Categories') {
      linkTo = `/machineUI/category/${props.machineID}`;
    } else {
      linkTo = `/machineUI/category/${props.brandOrCate}/${props.id}/${props.machineID}`;
    }
  }

  return (
    <div
      className="col-md-9 mb-4 category-card"
      style={
        props.showName
          ? {
              padding: '0',
            }
          : {
              //newly added
              padding: ' 0 15px',
              boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
            }
      }
    >
      <Link to={linkTo}>
        {props.column === '2' ? (
          <div
            className="card"
            style={
              props.showName
                ? {
                    padding: '0',
                  }
                : {
                    border: 'none',
                    borderRadius: '1em',
                    borderBottom: 'none',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    height: '195px',
                    paddingTop: '1rem',
                    justifyContent: 'center',
                  }
            }
          >
            <img
              height={props.showName ? '' : 195}
              src={props.image}
              alt=""
              className={props.showName ? 'image-one' : 'p-3'}
              tabIndex="-1"
            />
          </div>
        ) : (
          <div
            className="card"
            style={
              props.showName
                ? {
                    padding: '0',
                  }
                : {
                    border: 'none',
                    borderRadius: '1em',
                    borderBottom: 'none',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    height: '350px',
                    paddingTop: '1rem',
                    justifyContent: 'center',
                  }
            }
          >
            <img
              height={props.showName ? '' : 350}
              src={props.image}
              alt=""
              className={props.showName ? 'image-one' : 'p-3'}
              tabIndex="-1"
            />
          </div>
        )}
      </Link>
      {!props.showName && (
        <div className="card-body">
          <h5 className="card-category-title d-flex justify-content-center">{props.catename}</h5>
        </div>
      )}
    </div>
  );
}
